export default __webpack_public_path__ + "55cff4dff30dd2b5505794956f74b0aa.png";